import HeroSection from "./Components/HeroSection";
import TableCERF from "./Components/TableCERF";
import {useState} from "react";
import QuestionTabs from "../../practice/variables/QuestionTabs";
import {FaRegCommentDots, FaRegHandRock} from "react-icons/fa";
import {CgNotes} from "react-icons/cg";
import Tabs from "../../../../components/Tabs/Tabs";
import FormButton, {DetButton} from "../../../../components/Form/Button/FormButton";
import UseCefr from "../../../../hooks/useCefr";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import WordCefr from "./Components/WordCefr";
import SentenceCefr from "./Components/SentenceCefr";
import {useSession} from "../../../../redux/Reducers/AuthReducer";
import BuyMembershipModal from "../../../../Modals/buy-memebership-modal/buy-membership-modal";
import BuyMemberShip from "../../../../components/utils/buy-member-ship";

const TABS = [{
    title: "Word", key: "word", icon: FaRegCommentDots,
}, {
    title: "Sentence", key: "sentence", icon: CgNotes,
}]

export default function IndexCrf({className, ...props}) {
    const [activeTab, setActiveTab] = useState(TABS[0].key);
    const [text, setText] = useState("");
    const [data, error, isLoading, actions] = UseCefr()
    const {session, authActions} = useSession();

    function submit() {
        let wordCount = text.trim().split(" ").length === 1 ? text.trim().split(" ")[0].length === 0 ? 0 : text.trim().split(" ").length : text.trim().split(" ").length;
        actions.setError(null)
        if (activeTab === "word" && wordCount !== 1) {
            actions.setError({non_field_errors: ["please type one word only."]})
            return;
        } else if (activeTab === "sentence" && wordCount < 2) {
            actions.setError({non_field_errors: ["please type at least two words."]})
            return;
        }
        actions.checkCefr(activeTab, text);
    }


    return (
        <div className={` ${className} pb-4`}>
            <HeroSection/>
            <div className={"flex mt-4 flex-col w-full justify-center items-center"}>
                <div className={"w-full gap-4 flex flex-col lg:w-4/5 py-4 lg:py-10 px-8 lg:px-16"}>


                    <Tabs tabs={TABS} className={"mt-8"} defaultSelected={activeTab} onChange={setActiveTab}/>

                    {activeTab === "sentence" && !authActions.hasActiveSubscription() ? <BuyMemberShip/> : <>
                        <div className={"w-full mt-2 p-4 flex flex-col bg-gray-100 rounded-lg"}>
                    <textarea
                        placeholder={"Enter your text here"}
                        value={text}
                        onChange={(e) => {
                            setText(e.target.value)
                        }}
                        className={"w-full h-40  border-none outline-none bg-transparent "}
                    />
                            <p className={"text-base text-gray-400 text-end"}>
                                Word
                                count: {text.trim().split(" ").length === 1 ? text.trim().split(" ")[0].length === 0 ? 0 : text.trim().split(" ").length : text.trim().split(" ").length}
                            </p>
                        </div>
                        <div className={"w-full flex justify-center items-center"}>
                            {activeTab === "word" && !data?.data?.occurance && data?.data &&
                                <WordCefr data={data?.data}/>}
                            {activeTab === "sentence" && data?.data &&
                                <SentenceCefr data={data?.data?.occurance} sentence={data?.data?.sequence}/>}
                        </div>
                        <FormNoneFieldErrors errors={error?.non_field_errors}/>
                        <div>
                            <DetButton loading={isLoading} onClick={submit}
                                       className={"ml-auto mt-4 py-2 w-1/2 lg:w-1/4"}>Submit</DetButton>
                        </div>
                    </>}

                    <TableCERF/>
                </div>
            </div>
        </div>

    )
}